export default {
  methods: {
    triggerVueUpdate() {
      $(document).trigger('vue-update');
    }
  }
};